import React, { useState, useEffect } from 'react';

export default function SearchBar({ onSearch, initialValue = '' }) {
  const [searchInput, setSearchInput] = useState(initialValue);

  useEffect(() => {
    setSearchInput(initialValue);
  }, [initialValue]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearch(searchInput);
  };

  const handleClear = () => {
    setSearchInput('');
    onSearch('');
  };

  return (
    <form onSubmit={handleSubmit} className="relative" role="search">
      <label htmlFor="blog-search" className="sr-only">
        Search blog articles
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <svg 
            className="h-5 w-5 text-gray-400" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
            aria-hidden="true"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
            />
          </svg>
        </div>
        <input
          id="blog-search"
          type="search"
          value={searchInput}
          onChange={(e) => setSearchInput(e?.target?.value)}
          placeholder="Search articles by title or content..."
          className="block w-full pl-12 pr-12 py-3 border border-white/20 rounded-lg 
                     bg-white/10 backdrop-blur-sm text-white placeholder-blue-200
                     focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent
                     transition-all"
          aria-describedby="search-description"
        />
        {searchInput && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute inset-y-0 right-0 pr-4 flex items-center text-blue-200 hover:text-white transition-colors"
            aria-label="Clear search"
          >
            <svg 
              className="h-5 w-5" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
              aria-hidden="true"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        )}
      </div>
      <p id="search-description" className="sr-only">
        Enter keywords to search through article titles and content
      </p>
    </form>
  );
}